
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule, implementDeleteNavTabAction } from "../../../../dt-plugins/sidewindow/nav-tab";

import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";

import router from '../../../../router';
import { DistributionStatementService } from "../../services/statement.service";
import { fetchPropertiesWithArgsFlat } from "../../../../utility/fp";

const NavTabModule = getNavTabModule(types.DistributionStatementsDetails, 'distributionStatementDetails');
export const distributionStatementsActions = {


  async [types.DistributionStatementsList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    // console.log("PAYLOAD Filter", payload);

    if (searchMode == 'none') {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          DistributionStatementService.statementList()

        ]);

        // console.log("RES", res)

        commit(types.DistributionStatementsList.SET.ALL, res);  // <-- Directly Set the Data. Depends on your particular Logic
      } else {                // <-- Pagination Logic
        //res = await licenceAccountsService.licenceAccountRows(start);            // <-- Pagination Logic

        // console.log("res", res)

        // commit(types.DistributionStatementsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        //   ...getters.licenceAccountsList,
        //   licence_accounts: [
        //     ...getters.licenceAccountsList.licence_accounts,
        //     ...res.data.licence_accounts, // <-- append new Fetched List
        //   ]
        // });

        // Setting EOL
        // if (!(res?.data?.length <= 0)) {
        //   return EOL_REACHED;
        // }
      }

    } else if (searchMode == 'basic') {
      const { searchString, licence_statuses, royalty_period, invoice_project, statement_type } = basicFilter;

      res = await DistributionStatementService.statementFilter({ ...basicFilter });
      // console.log("res filter", res)
      if (start == 0) {
        commit(types.DistributionStatementsList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.distributionStatementList,
          statements: res.data.statements
        });
      }
      // else {                // <-- Pagination Logic
      //   commit(types.TrackList.SET.ALL, {               // <-- Pagination Logic
      //     ...getters.trackList,
      //     tracks: [
      //       ...getters.trackList.tracks,
      //       ...res.data // <-- append new Fetched List
      //     ]
      //   });
      // }


      // Setting EOL
      // if (!(res?.data?.length > 0)) {
      //   return EOL_REACHED;
      // }
    }
  },

  async [types.DistributionStatementsList.DELETE.SINGLE]({ commit }, payload) {
    const { statement_id } = payload


    commit(types.DistributionStatementsList.DELETE.SINGLE, payload)

    await DistributionStatementService.statementStatusInQueue(statement_id);
    await DistributionStatementService.deleteStatement(statement_id);

  },


  async [types.DistributionStatementsDetailsRefresh.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    let { flag, statement_id, reload } = payload;
    
    NavTabHelper.updateSingleNavTabDetails(statement_id, CostsDetails => {
      return {
        loading: true,
      }
    })
    let promiseArray = [
      DistributionStatementService.statementImportErrorData(statement_id),
      DistributionStatementService.statementData(statement_id),

    ]
    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      ...promiseArray
    ]);
    const finalDetails = { ...detailsData }

    NavTabHelper.setSingleNavTabDetails(statement_id, (detailsDict, statement) => {
      return {
        ...statement,
        ...finalDetails,
        loading: false,
      }
    })
  },
  async [types.DistributionStatementsDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, statement, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'statement_id';
    const itemName = 'statement';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'distributionStatementDetails';
    const DetailsAction = types.DistributionStatementsDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }
    // console.log(payload, primaryKeyValue)
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    const statementRes = await DistributionStatementService.statementImportData(primaryKeyValue);

    const finalDetails = { /*...detailsData*/...statementRes.data }

    
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        ...finalDetails,
        loading: true,
        import_result_summary_loading:true,
      }
    })
    console.log("statementRes", statementRes);

    const channelName = statementRes.data['statement'].digital_physical;

    let promiseArray = [
      DistributionStatementService.statementSummaryData(primaryKeyValue),
      DistributionStatementService.statementImportErrorData(primaryKeyValue),
      DistributionStatementService.statementData(primaryKeyValue),

    ]

    let promiseKey =[
      'statementSummaryData',
      'statementImportErrorData',
      'statementData',

    ]

    if (channelName == 'physical') {
      promiseKey = [
        ...promiseKey,
       'physicalStmtImportResultData',
       'statementImportResultData',
       'statementCostsData'

      ]
      // promiseArray = [
      //   ...promiseArray,
      //   DistributionStatementService.physicalStmtImportResultData(primaryKeyValue),
      //   DistributionStatementService.statementImportResultData(primaryKeyValue),
      //   DistributionStatementService.statementCostsData(primaryKeyValue)

      // ]
    } else if (channelName == 'digital') {
      promiseKey = [
        ...promiseKey,
       'digitalStmtImportResultData',
       'statementImportResultData'
      ]
      // promiseArray = [
      //   ...promiseArray,
      //   DistributionStatementService.digitalStmtImportResultData(primaryKeyValue),
      //   DistributionStatementService.statementImportResultData(primaryKeyValue)
      // ]
    } else if (channelName == 'costs' || channelName == 'income') {
        promiseKey = [
          ...promiseKey,
         'costIncomeStmtImportResultData',
         'statementIncomeData'
        ]
      // promiseArray = [
      //   ...promiseArray,
      //   DistributionStatementService.costIncomeStmtImportResultData(primaryKeyValue),
      //   DistributionStatementService.statementIncomeData(primaryKeyValue)
      // ]
    } else if (channelName == 'thirdparty' || channelName == 'performance') {
      promiseKey = [
        ...promiseKey,
       'thirdpartyPerformanceStmtImportResultData',
       'statementImportResultData'
      ]
      // promiseArray = [
      //   ...promiseArray,
      //   DistributionStatementService.thirdpartyPerformanceStmtImportResultData(primaryKeyValue),
      //   DistributionStatementService.statementImportResultData(primaryKeyValue)
      // ]
    }

    
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        loading: true,
      }
    })

    // HTTP Req
    // const detailsData = await HttpClient.mergeRequests([

    //   ...promiseArray
    //   // DistributionStatementService.physicalStmtImportResultData(primaryKeyValue),
    //   // DistributionStatementService.digitalStmtImportResultData(primaryKeyValue)
    // ]);
    await dispatch(types.DistributionStatementsDetails.FETCH.PARTIAL, {
      properties: [ ...promiseKey    ], statement_id: primaryKeyValue,
      parallel: false,
    });

    // console.log("detailsData", { ...detailsData, ...statementRes.data });

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        loading: false,
        display_statement_unmatched_lines_warning: false,
        display_statement_unmatched_lines_warning_loading: true
      }
    })
    DistributionStatementService.display_statement_unmatched_lines_warning(primaryKeyValue).then((res) => {
      console.log(res);
      NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
        return {
          ...statement,
          loading: false,
          display_statement_unmatched_lines_warning_loading: false,
          display_statement_unmatched_lines_warning: res.data.message_display === 1 ? true : false
        }
      })
    });

    

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        loading: false,
        import_result_summary_loading:false
      }
    })

    return finalDetails;
  },

  async [types.DistributionStatementsDetails.FETCH.PARTIAL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { properties, statement_id, parallel, setnull } = payload;
    console.log(":::::::::::::","FETCH PARTIAL",{ properties, statement_id, parallel, setnull })
    await fetchPropertiesWithArgsFlat(NavTabHelper, DistributionStatementService, properties, [statement_id], parallel, setnull);
  },

  ...NavTabModule.implementActions(
    'statement_id',
    'statement_list/statement_id/tab',
    'statement_list',
    () => router,
    'distribution',
    (value, key) => {
      console.log("value, key :::::::::::::PPPPPPPPPPPPPPPPAAAAAAAAAAAAAA", { value, key })

      // {{
      //   value.statement_import_info.account_name ||
      //   "Account Name"
      // }}
      // -
      // {{
      //   $dft.capHead(
      //     value.statement_import_info.description
      //   ) || "Description"
      // }}
      // {{
      //   `${value.statement.statement_year}/${value.statement.statement_period_txt}` ||
      //   "Description"
      // }}
      //?.split(' ')?.[0]
      const title = /*value?.statement_import_info ?*/ `${value.statement?.statement_year}/${value.statement?.statement_period_txt} ${value.statement_import_info?.account_name}` //: (value?.statement?.account_name) ? value?.statement?.account_name : key;
      const full_title = /*value?.statement_import_info ?*/ `${value.statement?.statement_year}/${value.statement?.statement_period_txt} ${value.statement_import_info?.account_name}` //: (value?.statement?.account_name) ? value?.statement?.account_name : key;
      
      return {
        title: title,
        full_title: full_title
      }
    }
  ),

  async [types.DistributionStatementsDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { statement } = item;
    const { statement_id } = statement;


    // console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        statement: {
          ...oldStatement.statement,
          [name]: value,
        }
      }
    });
    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, statement_id, name, value, 'l_statements')






  },

  async [types.DistributionContact.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    // console.log("payload", payload)

    const { external_id, item_contact } = payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, oldStatement) => {
      return {
        ...oldStatement,
        contact: item_contact
      };
    })
  },

  async [types.SET_DISTRIBUTION_STATEMENT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const statement_id = externalId;
    NavTabHelper.setSingleNavTabDetails(statement_id, (_, oldStatement) => {
      return {
        ...oldStatement,
        files: files,
      }
    });
  },


  async [types.DistributionImportMatch.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { statement_id, item } = payload;

    const { statement_line_id } = item;


    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        statement_lines: oldStatement.statement_lines.
          filter(e => e.statement_line_id != statement_line_id)
      }
    })

    const deletedImport = await DistributionStatementService.deleteNonMatchingStatementline(statement_line_id);

    // const deletedGenres = await releaseService.addRemoveGenre(release_id, payload.genre_id, genre_relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.DistributionImportMatch.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { statement_id, start } = payload;

    const res = await DistributionStatementService.statementImportErrorPage(statement_id, start);

    // console.log("RES::::::", res)

    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        statement_lines: [...oldStatement.statement_lines, ...res.data.statement_lines]

      }
    })

    // const deletedGenres = await releaseService.addRemoveGenre(release_id, payload.genre_id, genre_relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.DistributionImportMatch.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { statement_id, menu, min_income, currentChannel } = payload;

    //const { statement_line_id } = item;
    let statement_lines;

    switch (menu) {
      case 'group_by_identifier': {
        statement_lines = await DistributionStatementService.groupByIdentifier(statement_id);
        if (currentChannel == 'costs' || currentChannel == 'income') {
          const statement_lines2 = await DistributionStatementService.statementImportErrorData(statement_id);
          statement_lines = {
            data: {
              statement_lines: statement_lines.data.statement_lines.map((x, i) => {
                return {
                  ...x,
                  cost_pu: statement_lines2.data.statement_lines[i].cost_pu,
                  cost_group_name: statement_lines2.data.statement_lines[i].cost_group_name,
                  import_cat_no: statement_lines2.data.statement_lines[i].import_cat_no,
                }
              })
            }
          }
          // console.log("change:::", [...statement_lines2.data.statement_lines])
        }
        // const statement_lines2 = await DistributionStatementService.statementImportErrorData(statement_id);
        // statement_lines ={data:{ statement_lines:statement_lines1.data.statement_lines.map((x,i)=>{
        //     return {
        //       ...x,
        //       ...statement_lines2.data.statement_lines[i]
        //     }
        // })}}
        // console.log("change:::",[...statement_lines1.data.statement_lines ,...statement_lines2.data.statement_lines])
        break;
      }
      case 'run_id_match': {
        statement_lines = await DistributionStatementService.checkSupplierIds(statement_id);
        // console.log("change:::", statement_lines)
        break;
      }
      case 'delete_unmatched': {
        await DistributionStatementService.deleteAllUnmatched(statement_id);
        const resData = await DistributionStatementService.statementImportErrorData(statement_id);
        // console.log(resData, ":::::");
        statement_lines = resData
        // console.log("change:::", statement_lines)
        break;
      }
      case 'remove_minimal_income': {
        await DistributionStatementService.removeMinimalIncome(statement_id, min_income);
        const resData = await DistributionStatementService.statementImportErrorData(statement_id);
        // console.log(resData, ":::::");
        statement_lines = resData
        // console.log("change:::", statement_lines)
        break;
      }
      case 'split_statement': {
        await DistributionStatementService.splitMatchUnmatch(statement_id);
        const resData = await DistributionStatementService.statementImportErrorData(statement_id);
        // console.log(resData, ":::::");
        statement_lines = resData
        // console.log("change:::", statement_lines)
        break;
      }
    }


    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        statement_lines: statement_lines.data.statement_lines
      }
    })

    // const deletedImport = await DistributionStatementService.deleteNonMatchingStatementline(statement_line_id);

    // const deletedGenres = await releaseService.addRemoveGenre(release_id, payload.genre_id, genre_relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.DistributionStatementImportSetup.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    let { name, value, statement_id } = payload


    //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        statement: {
          ...oldStatement.statement,
          [name]: value,

        }
      }
    });

    if(name==='price_list_id'){
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      const json_data=JSON.parse(oldStatement.statement.json_data)
      return {
        statement: {
          ...oldStatement.statement,
          json_data: JSON.stringify({...json_data, price_list_id:value}),
          
        }
      }
    });
      const modifiedData = await DistributionStatementService.updateStatementPriceListId({statement_id:statement_id,price_list_id:value})
    }
    else{
      const modifiedRelease = await MHTTPCL.modifyJSON(undefined, statement_id, name, value, 'l_statements')
    }
    






  },


  async [types.DistributionStatementSalesDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { value, statement_id, objKey, kVal } = payload


    //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        [objKey]: oldStatement[objKey].map(e => {
          if (e.statement_line_id == kVal) {
            return {
              ...e,
              cost_group_id: value
            }
          } else {
            return e
          }
        })
      }
    });
    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, 'cost_group_id', value, 'l_statement_lines')






  },

  async [types.DistributionStatementSalesDetails.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { statement_id, objKey, statement_line_id } = payload


    //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        [objKey]: oldStatement[objKey].filter(e => e.statement_line_id != statement_line_id)
      }
    });
    const deletedOBJ = await DistributionStatementService.deleteMatchingStatementline(statement_line_id)






  },


  async [types.DistributionStatementImportResultDigital.UPDATE.ALL]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { amount, statement_id } = payload;

    await DistributionStatementService.ppuByFixAmount(statement_id, amount);


    const resData = await DistributionStatementService.digitalStmtImportResultData(statement_id);


    // console.log("::::::::::::::::", resData, ":::::::::::::", payload);


    //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        ...resData.data
      }
    });










  },

  async [types.DistributionStatementFile.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
    // console.log("{file , statement_id}", payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { file, statement_id } = payload;

    // console.log()
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        ...oldStatement,
        file: { ...file }
      }
    });

  },

  async [types.DistributionStatementImportResultTotal.UPDATE.MULTIPLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { statement_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        statement: {
          ...oldStatement.statement,
          

        },
        import_result_summary_loading:true,
      }
    });

    const res = await DistributionStatementService.refreshStatementCalculation(statement_id);

     console.log("RES", res)

    // console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        statement: {
          ...oldStatement.statement,
          ...res.data.statement,
          
        },
        import_result_summary_loading:false
      }
    });
  },


  async [types.DistributionStatementImportResultTotal.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { statement_id, item_id, value,index } = payload;

    NavTabHelper.updateSingleNavTabDetails(statement_id, (oldStatement) => {
      return {
        costgroup_lines: oldStatement.costgroup_lines.map((x,i) => {
          if (i == index ) {
            return {
              ...x,
              cost_group_id: value
            }
          }
          return { ...x }
        })
      }
    });
  },

  async [types.SET_SELECTED_COLUMNS]({ dispatch, getters }, payload) {

    const { statement_id, selected_columns, statement_preset_id } = payload;

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);


    NavTabHelper.setSingleNavTabDetails(statement_id, (_, oldStatement) => {
      return {
        ...oldStatement,
        selected_columns: selected_columns,
      }
    });
  },


}
